import { compact, concat, head, isArray, isPlainObject, map, split, tail } from 'lodash/fp';
import generatePortableText from '@ahmdigital/logic/lib/content/utils/generate-portable-text';
import portableTextToPlain from '@ahmdigital/logic/lib/content/utils/portable-text-to-plain';

import type { Maybe } from '../../types/__codegen__/sanity/graphql';
import type { PortableTextType } from '../../types/sanityInternal';

export const FOOTNOTE_PLACEHOLDER = '[FOOTNOTE_PLACEHOLDER]';

type Props = {
  text?: string | PortableTextType[];
  footnote?: {
    reference?: string | Maybe<string>;
  };
  isPortableText?: boolean;
};

const insertFootnoteReference = ({ text, footnote }: Props) => {
  const isPortableText = isArray(text) || isPlainObject(text);
  const textContent = isPortableText ? portableTextToPlain(text as PortableTextType[]) : (text as string);
  const splitText = split(FOOTNOTE_PLACEHOLDER, textContent);

  return generatePortableText({
    value: compact(
      concat(
        [{ value: head(splitText) }, footnote && { type: 'footnote', value: footnote.reference }],
        map((trailingText) => ({ value: trailingText }), tail(splitText)),
      ),
    ),
  });
};

export default insertFootnoteReference;
